/* unplugin-vue-components disabled */import script from "./no-data.vue?vue&type=script&setup=true&lang=ts"
export * from "./no-data.vue?vue&type=script&setup=true&lang=ts"

import "./no-data.vue?vue&type=style&index=0&id=e9352e2e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9352e2e"]])

export default __exports__